// Similitud liviana entre hechos, client-side. Sirve para el HINT anti-duplicados de la cola
// de curado (cara B de "sin dedup automática": el mismo hecho se re-extrae en cada reunión y
// la cola se inunda). NO decide nada: sólo le avisa al revisor "esto se parece a algo ya
// aprobado". Es un heurístico de overlap de palabras, no semántico (eso es V3/pgvector).

const STOPWORDS = new Set([
    'el', 'la', 'los', 'las', 'de', 'del', 'que', 'con', 'por', 'para', 'una', 'uno', 'unas',
    'unos', 'y', 'o', 'en', 'su', 'sus', 'al', 'es', 'un', 'se', 'lo', 'le', 'les', 'mas',
    'pero', 'como', 'sobre', 'sin', 'tiene', 'tienen', 'cliente',
]);

export function tokens(text) {
    return (text || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')   // saca tildes (á->a, ñ->n)
        .replace(/[^a-z0-9 ]/g, ' ')
        .split(/\s+/)
        .filter((w) => w.length > 2 && !STOPWORDS.has(w));
}

export function jaccard(aTokens, bTokens) {
    const a = new Set(aTokens);
    const b = new Set(bTokens);
    if (a.size === 0 || b.size === 0) return 0;
    let inter = 0;
    a.forEach((w) => {
        if (b.has(w)) inter += 1;
    });
    return inter / (a.size + b.size - inter);
}

// Devuelve el hecho del pool más parecido al target (mismo tipo + overlap >= threshold), o null.
export function findSimilar(fact, pool, threshold = 0.45) {
    const ft = tokens(fact.statement);
    let best = null;
    let bestScore = 0;
    pool.forEach((candidate) => {
        if (candidate.id === fact.id) return;
        if (candidate.fact_type !== fact.fact_type) return;
        const score = jaccard(ft, tokens(candidate.statement));
        if (score > bestScore) {
            bestScore = score;
            best = candidate;
        }
    });
    return bestScore >= threshold ? best : null;
}
